import OpText, { TextVariant } from 'components/Common/op-ui-wrappers/OpText/OpText';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isDesktop from 'store/app/selector/isDesktop';
import getTotalResultsAvailable from 'store/search/selector/getTotalResultsAvailable';
import getStudioSearchQuery from 'store/studioSearch/selector/getStudioSearchQuery';
import getStudioTotalResultsAvailable from 'store/studioSearch/selector/getStudioTotalResultsAvailable';
import styles from './SearchSummary.module.scss';

const SearchSummary = () => {
  const { t } = useTranslation();
  const isDesktopDevice = useSelector(isDesktop);
  const totalFamilies = useSelector(getTotalResultsAvailable);
  const totalImages = useSelector(getStudioTotalResultsAvailable);
  const query = useSelector(getStudioSearchQuery);

  if (totalImages && !totalFamilies) {
    return (
      <section className={styles.container}>
        <OpText block variant={isDesktopDevice ? 'headline-medium-regular' : 'title-large-regular'}>
          <Trans
            t={t}
            i18nKey="txt_search_results_count_with_images_only"
            values={{ total: totalFamilies, images: totalImages, query }}
            components={{ u: <u style={{ fontWeight: 400 }} />, b: <b /> }}
          />
        </OpText>

        <OpText block variant={`body-${isDesktopDevice ? 'large' : 'medium'}-light` as TextVariant}>
          <Trans
            t={t}
            i18nKey="txt_search_results_count_with_images_only_subtext"
            values={{ total: totalFamilies, images: totalImages, query }}
            components={{ u: <u style={{ fontWeight: 400 }} />, b: <b /> }}
          />
        </OpText>
      </section>
    );
  }

  return (
    <section className={styles.container}>
      <OpText block variant={isDesktopDevice ? 'headline-medium-regular' : 'title-large-regular'}>
        <Trans t={t} i18nKey="txt_search_results_from_studio_images" values={{ query }} components={{ b: <b /> }} />
      </OpText>

      <OpText block variant={`body-${isDesktopDevice ? 'large' : 'medium'}-light` as TextVariant}>
        <Trans t={t} i18nKey="txt_premium_photos_from_getty" values={{ count: totalImages }} components={[<></>]} />
      </OpText>
    </section>
  );
};

export default SearchSummary;
